import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import globalSettingsStores from '../../../../../../stores/settings-stores';

export const addNewClassListAttributesValuesOperations = async (
  buildingId: number,
  classId: number,
  listId: number,
  attributeValues: {
    attributeId: number;
    numericValue?: number;
    boolValue?: boolean;
  }[],
  setLoading: (loading: boolean) => any,
  onHide: () => any,
  onSuccess?: () => void,
) => {
  try {
    setLoading(true);
    const res = await appApi.addClassAttributesToClass(
      buildingId,
      classId,
      listId,
      attributeValues,
    );

    globalSettingsStores.fetchSetting(res.data.body);

    onSuccess?.();
    onHide();
    setLoading(false);
  } catch (e) {
    setLoading(false);
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים...');
  }
};
